import React, { useEffect, useState } from 'react'
import axios from 'axios'
import style from './Cost.module.scss'
import { useFormik } from 'formik'
import { useSelector } from 'react-redux'
import { Link, useHistory, useParams } from 'react-router-dom'
import adminStyles from '../AdminManageLayout.module.scss'
import _ from 'lodash'

export default function CreateCost({ isEdit = false }) {
  const auth = useSelector((state) => state.admin.auth)
  const { costId } = useParams()
  const [universities, setUniversities] = useState([])
  const [initialValues, setInitialValues] = useState({
    name: '',
    desc: '',
    universityName: '',
  })
  const history = useHistory()
  const [status, setStatus] = useState({})

  useEffect(() => {
    const initCreateCost = async () => {
      let universitieslist = []
      await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_URL}/admin/universities`,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      })
        .then(({ data }) => {
          universitieslist = data
          setUniversities(data)
        })
        .catch((error) => {
          console.error(error)
        })
      if (isEdit) {
        await axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/admin/cost/${costId}`,
          headers: {
            Authorization: 'Bearer ' + auth.token,
          },
        })
          .then(({ data }) => {
            console.log('data', data)
            setInitialValues({
              ...data,
              universityName: _.find(universitieslist, { id: data.universityId })?.name,
            })
          })
          .catch((error) => {
            console.error(error)
          })
      }
    }
    initCreateCost()
    return () => {}
  }, [auth.token, costId, isEdit])

  useEffect(() => {
    if (isEdit) {
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_URL}/admin/cost/${costId}`,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      })
        .then(({ data }) => {
          console.log(data)
          setInitialValues(data)
        })
        .catch((error) => {
          console.error(error)
        })
    }
    return () => {}
  }, [auth.token, costId, isEdit])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: (values) => {
      setStatus({
        buttonText: 'SENDING ...',
        desc: 'กำลังส่ง...',
      })
      axios({
        url: isEdit
          ? `${process.env.REACT_APP_API_URL}/admin/cost/${costId}`
          : `${process.env.REACT_APP_API_URL}/admin/cost/new`,
        method: 'POST',
        timeout: 5000,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
        data: _.pickBy({
          ...formik.values,
          universityId: universities.find((university) => university.name === formik.values.universityName)
            ?.id,
        }),
      })
        .then((response) => {
          setStatus({
            buttonText: 'SUCCESS',
            desc: `เสร็จสิ้น ${new Date().toLocaleString()}`,
          })
          return history.push('/admin/cost')
        })
        .catch((error) => {
          if (error.code === 'ECONNABORTED') {
            return setStatus({
              buttonText: 'CANNOT CONNECT',
              desc: 'กรุณาตรวจสอบการเชื่อมต่อ',
            })
          }
          return setStatus({
            buttonText: 'NOT SUCCESS',
            desc: 'ไม่สำเร็จ',
          })
        })
    },
  })

  return (
    <React.Fragment>
      <div className={style.cover}>
        <div className={style.wrapper}>
          <div className={style.headingRow}>
            <h1>New Cost</h1>
            <Link to='/admin/cost' className={adminStyles.addNewBlog}>
              กลับ
            </Link>
          </div>
          <form onSubmit={formik.handleSubmit} className={style.courseForm}>
            <div className={style.coverInput}>
              <label className={style.headInput}>ชื่อ</label>
              <input
                id='name'
                name='name'
                type='text'
                placeholder='ชื่อค่าใช้จ่าย'
                required
                onChange={formik.handleChange}
                value={formik.values.name}
              />
            </div>
            <div className={style.coverInput}>
              <label className={style.headInput}>ค่าใช้จ่าย</label>
              <input
                id='value1'
                name='value1'
                type='text'
                placeholder='ค่าใช้จ่าย'
                onChange={formik.handleChange}
                value={formik.values.value1}
                required
              />
            </div>
            <div className={style.coverInput}>
              <label className={style.headInput}>ค่าใช้จ่าย 2</label>
              <input
                id='value2'
                name='value2'
                type='text'
                placeholder='ค่าใช้จ่ายมากสุด *กรณีเป็นแบบช่วง'
                onChange={formik.handleChange}
                value={formik.values.value2}
              />
            </div>
            <div className={style.coverInput}>
              <label className={style.headInput}>มหาวิทยาลัย</label>
              <input
                id='univerisityName'
                name='universityName'
                list='universityNames'
                placeholder='เลือกมหาวิทยาลัย'
                onChange={formik.handleChange}
                value={formik.values.universityName}
                required
              />
            </div>
            <datalist
              id='universityNames'
              name='universityNames'
              type='text'
              onChange={formik.handleChange}
              value={formik.values.universityId}
              required
            >
              {universities.map((university) => (
                <option key={university.id} value={university.name} />
              ))}
            </datalist>
            <button type='submit' className={adminStyles.addNewBlog}>
              {status?.desc || 'ยืนยัน'}
            </button>
          </form>
        </div>
      </div>
    </React.Fragment>
  )
}
